import { connect } from 'react-redux'
import SchoolCounters from './school-counters'
import { getSchool } from '../../../../../../stores/school/school.selectors'

const mapStateToProps = (state, { me }) => {
  const school = getSchool(state)
  return {
    views: school.number_of_works_views,
    published: school.number_of_published_works,
    authors: school.number_of_published_works_authors
  }
}

export default connect(
  mapStateToProps,
  null
)(SchoolCounters)
